import { createSlice } from '@reduxjs/toolkit';
import aiSummarizerInitialState from './aiSummarizer.initialState';
import {
  fetchAISummaryArchive,
  fetchAISummaryArchives,
  fetchAISummary,
} from './aiSummarizer.actions';

const aiSummarizerSlice = createSlice({
  name: 'aiSummarizerSlice',
  initialState: aiSummarizerInitialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAISummary.pending, (state, action) => {
        const { platform, type = 'modal' } = action.meta.arg;
        const summaryPlatform = type === 'modal' ? 'modal' : platform;
        state.contentAISummary[summaryPlatform].data = {};
        state.contentAISummary[summaryPlatform].error = null;
        state.contentAISummary[summaryPlatform].loading = true;
      })
      .addCase(fetchAISummary.rejected, (state, action) => {
        const { platform, type = 'modal' } = action.meta.arg;
        const summaryPlatform = type === 'modal' ? 'modal' : platform;
        state.contentAISummary[summaryPlatform].data = {};
        state.contentAISummary[summaryPlatform].loading = false;
        state.contentAISummary[summaryPlatform].error = action.payload;
        if (action.payload?.response?.status === 429) {
          const prev = state.contentAISummary.limitedRequestCount || 0;
          state.contentAISummary.limitedRequestCount = prev + 1;
        }
      })
      .addCase(fetchAISummary.fulfilled, (state, action) => {
        const { payload } = action;
        const { platform, type = 'modal' } = action.meta.arg;
        const summaryPlatform = type === 'modal' ? 'modal' : platform;
        const limit = payload?.meta?.limit || 0;
        const attempts = payload?.meta?.attempts || 0;
        state.contentAISummary[summaryPlatform].data = payload;
        state.contentAISummary[summaryPlatform].loading = false;
        state.contentAISummary[summaryPlatform].error = null;
        state.contentAISummary.limitedRequestCount = 0;
        const remaining = limit - attempts;
        state.contentAISummaryArchives.data.remainingLimit =
          remaining > 0 ? remaining : 0;
        state.contentAISummaryArchives.data.limit = limit;
      })
      .addCase(fetchAISummaryArchives.pending, (state) => {
        state.contentAISummaryArchives.data = {};
        state.contentAISummaryArchives.error = null;
        state.contentAISummaryArchives.loading = true;
      })
      .addCase(fetchAISummaryArchives.rejected, (state, action) => {
        state.contentAISummaryArchives.data = {};
        state.contentAISummaryArchives.loading = false;
        state.contentAISummaryArchives.error = action.payload;
      })
      .addCase(fetchAISummaryArchives.fulfilled, (state, action) => {
        state.contentAISummaryArchives.data = action.payload;
        state.contentAISummaryArchives.loading = false;
        state.contentAISummaryArchives.error = null;
      })
      .addCase(fetchAISummaryArchive.pending, (state) => {
        state.contentAISummary.modal.data = {};
        state.contentAISummary.modal.error = null;
        state.contentAISummary.modal.loading = true;
      })
      .addCase(fetchAISummaryArchive.rejected, (state, action) => {
        state.contentAISummary.modal.data = {};
        state.contentAISummary.modal.loading = false;
        state.contentAISummary.modal.error = action.payload;
      })
      .addCase(fetchAISummaryArchive.fulfilled, (state, action) => {
        state.contentAISummary.modal.data = action.payload;
        state.contentAISummary.modal.loading = false;
        state.contentAISummary.modal.error = null;
        state.contentAISummary.data = action.payload;
        state.contentAISummary.loading = false;
        state.contentAISummary.error = null;
      });
  },
});

export default aiSummarizerSlice;
